import React, { useState, useEffect } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { useParams, useHistory } from "react-router-dom";
import { Loading, WarningAlert } from "../components";
import { sitesApi } from "../api/entitiesApi";

function RedirectToCustomerDetails() {
  const { siteId } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState("");
  const [didRedirect, setDidRedirect] = useState(false);

  useEffect(() => {
    async function fetchSiteAndRedirect() {
      try {
        const site = await sitesApi.getEntity(siteId);
        if (!site || !site.customer_id) {
          throw new Error("Site not found or missing customer_id");
        }
        history.replace(`/customerDetails/${site.customer_id}`);
        setDidRedirect(true);
      } catch (err) {
        setFetchError(err.message || "Failed to load site");
      } finally {
        setLoading(false);
      }
    }

    fetchSiteAndRedirect();
  }, [siteId, history]);

  if (loading) {
    return <Loading />;
  }

  if (didRedirect) {
    return null;
  }

  const displayError = fetchError.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

  return (
    <div className="d-flex flex-column align-items-center">
      <WarningAlert message={displayError} />
    </div>
  );
}

export default withAuthenticationRequired(RedirectToCustomerDetails, {
  onRedirecting: () => <Loading />,
});
